import { DataRouteDefinition } from "routes/data-routes/types";
import { Coupon } from "types/Coupons";


export const ActiveCouponsDataRoutePath = "/data-routes/billing-data/coupons";

export type ActiveCouponsDataRouteType = Required<DataRouteDefinition<Coupon[], "activeCoupons", typeof ActiveCouponsDataRoutePath>>;
